import { Typography } from '@mui/material';
import { TournamentTeamStatus as CoreTournamentTeamStatus } from '@okletsplay/core';
import classNames from 'classnames';
import React, { FC, useMemo } from 'react';
import { useStyles } from './TournamentTeamStatus.styles';

interface TournamentTeamStatusProps {
  status: CoreTournamentTeamStatus;
}

export const TournamentTeamStatus: FC<TournamentTeamStatusProps> = ({ status }) => {
  const { classes } = useStyles();

  const statusLabel = useMemo(() => {
    return status === CoreTournamentTeamStatus.Checkin ? 'Check-in' : status;
  }, [status]);

  if (!status) {
    return null;
  }

  return (
    <Typography className={classNames(classes.root, classes[status])}>{statusLabel}</Typography>
  );
};
